import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { AnnouncementBar } from './components/AnnouncementBar';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { BonusesSection } from './components/BonusesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { PainPointsSection } from './components/PainPointsSection';
import { SocialProofSection } from './components/SocialProofSection';
import { PriceSummarySection } from './components/PriceSummarySection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { StickyCTABar } from './components/StickyCTABar';
import { RecentPurchasePopup } from './components/RecentPurchasePopup';
export function App() {
  return <div className="min-h-screen w-full bg-brand-main font-sans text-brand-text selection:bg-brand-amber/30" data-id="element-0" data-mp="3ikqz80j1f669">
      <MetaPixel data-id="element-1" data-mp="3mkhou0wtvg97" />
      <AnnouncementBar data-id="element-2" data-mp="3mjzpuwis6nxl" />
      <main data-id="element-3" data-mp="3mj6jvxrnc2gi">
        <HeroSection data-id="element-4" data-mp="3rc9i4j7dc031" />
        <StatsBar data-id="element-5" data-mp="3rbzlwdvqcwow" />
        <BonusesSection data-id="element-6" data-mp="3rdkgg3i1ofmr" />
        <BenefitsSection data-id="element-7" data-mp="3recf5n6xuth9" />
        <PainPointsSection data-id="element-8" data-mp="5ygolyg4xb6" />
        <SocialProofSection data-id="element-9" data-mp="682rygdekbl" />
        <PriceSummarySection data-id="element-10" data-mp="56nfhsbnbo2" />
        <HowItWorksSection data-id="element-11" data-mp="2zl3alhpbj03q" />
        <GuaranteeSection data-id="element-12" data-mp="2zlv7cvunj3vl" />
        <FAQSection data-id="element-13" data-mp="2zmo557bmuj1l" />
        <FinalCTASection data-id="element-14" data-mp="2zn6biws0edn8" />
      </main>
      <Footer data-id="element-15" data-mp="33m5cy7ej7s9x" />
      <StickyCTABar data-id="element-16" data-mp="33nq5xsl7735o" />
      <RecentPurchasePopup data-id="element-17" data-mp="33n6y54p9hv5d" />
    </div>;
}